import React from 'react'
import { CloseSVG } from '../../Icons/Basic'
import { MessageConfig, MessageType } from './Message.constants'
import {
  MessageContainer,
  MessageCTAButton,
  MessageCTALink,
  MessageCTARouterLink,
  MessageContent,
  MessageText,
  MessageIcon,
  MessageCloseButton,
} from './Message.styles'
import { MessageCTA } from './Message.types'

export const Message = ({
  messageType,
  messageText,
  ctaButton,
  ctaButtons,
  ctaContent,
  size = 'small',
  padding = '16px',
  onDismiss,
  fullWidth,
}: {
  messageType: MessageType
  messageText: string
  ctaButton?: MessageCTA
  ctaButtons?: MessageCTA[]
  ctaContent?: React.ReactNode
  size?: 'small' | 'medium'
  padding?: string
  onDismiss?: () => void
  fullWidth?: boolean
}): JSX.Element => {
  const { icon, backgroundColor, borderColor } = MessageConfig[messageType]

  const renderCTAButton = (button: MessageCTA, index = 0) => {
    if (button.to) {
      return (
        <MessageCTARouterLink
          key={index}
          to={button.to}
          $withMargin={button.withMargin}
          $size={size}
        >
          {button.text}
        </MessageCTARouterLink>
      )
    }
    if (button.href) {
      return (
        <MessageCTALink
          key={index}
          href={button.href}
          $withMargin={button.withMargin}
          $size={size}
        >
          {button.text}
        </MessageCTALink>
      )
    }
    return (
      <MessageCTAButton
        key={index}
        onClick={button.onClick}
        $withMargin={button.withMargin}
        $size={size}
      >
        {button.text}
      </MessageCTAButton>
    )
  }

  const renderCTA = () => {
    const buttons = ctaButtons || (ctaButton ? [ctaButton] : [])
    return buttons.map(renderCTAButton)
  }

  return (
    <MessageContainer
      backgroundColor={backgroundColor}
      borderColor={borderColor}
      padding={padding}
      $fullWidth={fullWidth}
    >
      <MessageContent $fullWidth={fullWidth}>
        <MessageIcon $size={size}>{icon}</MessageIcon>
        <MessageText $size={size}>{messageText}</MessageText>
      </MessageContent>
      {ctaContent || renderCTA()}
      {onDismiss && (
        <MessageCloseButton onClick={onDismiss} $size={size}>
          <CloseSVG />
        </MessageCloseButton>
      )}
    </MessageContainer>
  )
}
